import { render } from "./CounterOfferPreview.vue?vue&type=template&id=be15127e&scoped=true&ts=true&lang=pug"
import script from "./CounterOfferPreview.vue?vue&type=script&lang=ts"
export * from "./CounterOfferPreview.vue?vue&type=script&lang=ts"

import "./CounterOfferPreview.vue?vue&type=style&index=0&id=be15127e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be15127e"]])

export default __exports__